import { render, staticRenderFns } from "./PersonalModal.vue?vue&type=template&id=0e0d3d94"
import script from "./PersonalModal.vue?vue&type=script&lang=ts"
export * from "./PersonalModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports